import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getStaticEquipmentLists,
  queryStaticEquipmentAccessoryWithDocuments
} from '../../../api/static-equipment-lists';
import { DocumentWithProjectUser } from '../Document/documentSlice';

export const getStaticEquipmentListsAsync = createAsyncThunk(
  'staticEquipmentLists/getStaticEquipmentLists',
  getStaticEquipmentLists
);

export const queryStaticEquipmentAccessoryWithDocumentsAsync = createAsyncThunk(
  'staticEquipmentLists/queryStaticEquipmentAccessoryWithDocuments',
  queryStaticEquipmentAccessoryWithDocuments
);

interface StaticAccessoryList {
  id: number;
  name: string;
}

interface StaticEquipmentListState {
  data: {
    id: number;
    name: string;
    staticAccessoryLists: StaticAccessoryList[];
  }[];
  templateWithDocument: {
    id: number;
    name: string;
    documents: DocumentWithProjectUser[];
  }[];
}

const initialState: StaticEquipmentListState = {
  data: [],
  templateWithDocument: []
};

export default createSlice({
  name: 'staticEquipmentLists',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStaticEquipmentListsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      queryStaticEquipmentAccessoryWithDocumentsAsync.fulfilled,
      (state, action) => {
        state.templateWithDocument = action.payload.data;
      }
    );
  }
});
